import moment from 'moment';
import IntAssessHdrService from "@/service/IntAssessHdrService";
import { IntAssessHdr } from "@/model/IntAssessHdr";
import SweetAlertService from "@/service/SweetAlertService";
import MenuRightSerivce from "@/service/MenuRightService";
import JobsService from "@/service/JobsService";
import UserService from "@/service/UserService";
import StoreGetter from "@/constants/StoreGetter";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Paginate from "vuejs-paginate";
import Settings from '../../../constants/Settings';
export default {
  data: () => ({
    breadcrumb: [
      {
        text: 'Candidates',
        disabled: false,
        href: 'InviteNewCandidate',
      },
      {
        text: 'Enquiry',
        disabled: true,
        href: 'Enquiry',
      },
    ],
    dictEnum: dictEnum,
    date: new Date(),
    jobCode: '',
    status: '',
    offerBy: '',
    searchText: '',
    jobCodeList: [],
    statusList: [],
    userList: [],
    intAssessHdrList: [],
    IsLoaded: true,
    tempIntAssessHdr: new IntAssessHdr(),
    interViewStatus: '',
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: this.currentSelectedPage + 1,
    totalRecords: 0,
    goPage: '',
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.Enquiry,
    Settings: Settings,
  }),
  components: {
    paginate: Paginate,
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  mounted() {
    var self = this;
    self.init();
    self.assignRights();
    self.scrollContent();
    self.getAllJob();
    self.getAllStatus();
    self.getAllUsers();
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var contentHeight = $(".content-header").height();
      var jobOfferSearchHeight = $(".eqr-top").height();
      var jobHeadHeight = $(".eqr-bottom .box-header").height();
      var tableHeaderHeight = $("table thead").height();
      var pagginationHeight = $(".paggination-start").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var nHeight = contentHeight != undefined ? contentHeight : 36;
      var jobHeight = jobOfferSearchHeight != undefined ? contentHeight : 105;
      var jobTitleHeight = jobHeadHeight != undefined ? contentHeight : 34;
      var tHeadHeight = tableHeaderHeight != undefined ? tableHeaderHeight : 52;
      var paggHeight = pagginationHeight != undefined ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - nHeight - jobHeight - jobTitleHeight - tHeadHeight - paggHeight;
      self.take = Number((tableHeight / 47).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllJob() {
      var self = this;
      const obj = {};
      const response = await JobsService.getAllJobs(obj);
      if (response.data.IsSuccess) {
        self.jobCodeList = response.data.Data;
        self.getAllEnquiryIntAssessHdrList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllStatus() {
      var self = this;
      const obj = {};
      const response = await IntAssessHdrService.getAllStatus(obj);
      if (response.data.IsSuccess) {
        var statusList = response.data.Data;
        if (statusList != null && statusList.length > 0) {
          self.statusList = statusList.filter(obj => obj.StatusCode == '85' || obj.StatusCode == '91' || obj.StatusCode === '92' || obj.StatusCode === '93');
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllUsers() {
      var self = this;
      const obj = {
        searchText: this.searchText
      };
      const response = await UserService.getAllUsers(obj);
      if (response.data.IsSuccess) {
        self.userList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllEnquiryIntAssessHdrList() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
        jobCode: self.jobCode,
        status: self.status,
        offerBy: self.offerBy,
        searchText: self.searchText
      }
      const response = await IntAssessHdrService.getAllEnquiryIntAssessHdrByJobCodeAndStatus(obj);
      if (response.data.IsSuccess) {
        self.intAssessHdrList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.fillIntAssessHdrData();
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllEnquiryIntAssessHdrByJobCodeAndStatus() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
        jobCode: self.jobCode,
        status: self.status,
        offerBy: self.offerBy,
        searchText: self.searchText
      }
      const response = await IntAssessHdrService.getAllEnquiryIntAssessHdrByJobCodeAndStatus(obj);
      if (response.data.IsSuccess) {
        self.intAssessHdrList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.fillIntAssessHdrData();
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    scrollContent: function () {
      $(".body-scroll-area").mCustomScrollbar({
        theme: "dark",
        scrollInertia: 60,
        scrollbarPosition: "inside",
        axis: "y"
      });
    },
    OnEnquiryIntAssessHdrSelection: function (item, index) {
      var self = this;
      self.IsLoaded = false;
      self.intAssessHdrList.forEach(element => {
        if (element.tempCode == item.tempCode) {
          self.IsLoaded = true;
          element.IsEditMode = true;
          self.tempIntAssessHdr = element;
        } else {
          self.IsLoaded = true;
          element.IsEditMode = false;
        }
      });
      self.IsLoaded = true;
    },
    openOfferPopup: function (item) {
      var self = this;
      self.interViewStatus = item.IntStatus;
      $('#makeOffer').modal('show');
    },
    closeOfferPopup: function () {
      var self = this;
      self.interViewStatus = '';
      $('#makeOffer').modal('hide');
    },
    async updateIntAssessHdrStatus() {
      var self = this;
      if (self.interViewStatus == 85) {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.WARN_SelectOfferResult));
        return;
      }
      if (self.interViewStatus == 93 && self.tempIntAssessHdr.IntAssessLogModel.LogMsg == '') {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.LBL_RejReason) + self.t.t(self.dictEnum.WARN_IsRequired));
        return;
      }
      else {
        if (self.interViewStatus == 93) {
          self.tempIntAssessHdr.DateOffer = '1900-01-01';
        }
        else {
          self.tempIntAssessHdr.DateOffer = moment().format("YYYY-MM-DD");
          self.tempIntAssessHdr.OfferBy = self.$store.getters[StoreGetter.user].UserID;
        }
        self.tempIntAssessHdr.IntStatus = self.interViewStatus;
      }
      $('#makeOffer').modal('hide');
      self.updateIntAssessHdrData();
    },
    async updateIntAssessHdrData() {
      var self = this;
      if (self.tempIntAssessHdr.CandID != "" && self.tempIntAssessHdr.JobAdCode != "" && self.tempIntAssessHdr.Seq != "") {
        if (self.tempIntAssessHdr.DateCommence != null && self.tempIntAssessHdr.DateCommence != "") {
          self.tempIntAssessHdr.DateCommence = moment(String(self.tempIntAssessHdr.DateCommence)).format("YYYY-MM-DD");
        }
        else {
          self.tempIntAssessHdr.DateCommence = '1900-01-01';
        }
        if (self.tempIntAssessHdr.DateInt != null && self.tempIntAssessHdr.DateInt != "") {
          self.tempIntAssessHdr.DateInt = moment(String(self.tempIntAssessHdr.DateInt)).format("YYYY-MM-DD HH:mm");
        }
        else {
          self.tempIntAssessHdr.DateInt = '1900-01-01 00:00';
        }
        if (self.tempIntAssessHdr.DateContSign == '' || self.tempIntAssessHdr.DateContSign == undefined || self.tempIntAssessHdr.DateContSign == null) {
          self.tempIntAssessHdr.DateContSign = '1900-01-01';
        }
        else {
          if (self.tempIntAssessHdr.ContSignBy == '' || self.tempIntAssessHdr.ContSignBy == null) {
            self.tempIntAssessHdr.ContSignBy = self.$store.getters[StoreGetter.user].UserID;
          }
        }
        if (self.tempIntAssessHdr.DateRefChk == '' || self.tempIntAssessHdr.DateRefChk == undefined || self.tempIntAssessHdr.DateRefChk == null) {
          self.tempIntAssessHdr.DateRefChk = '1900-01-01';
        }
        else {
          if (self.tempIntAssessHdr.RefChkBy == '' || self.tempIntAssessHdr.RefChkBy == null) {
            self.tempIntAssessHdr.RefChkBy = self.$store.getters[StoreGetter.user].UserID;
          }
        }
        if (self.tempIntAssessHdr.DateDataEntry == '' || self.tempIntAssessHdr.DateDataEntry == undefined || self.tempIntAssessHdr.DateDataEntry == null) {
          self.tempIntAssessHdr.DateDataEntry = '1900-01-01';
        }
        else {
          if (self.tempIntAssessHdr.DataEntryBy == '' || self.tempIntAssessHdr.DataEntryBy == null) {
            self.tempIntAssessHdr.DataEntryBy = self.$store.getters[StoreGetter.user].UserID;
          }
        }
        if (self.tempIntAssessHdr.DateVerified == '' || self.tempIntAssessHdr.DateVerified == undefined || self.tempIntAssessHdr.DateVerified == null) {
          self.tempIntAssessHdr.DateVerified = '1900-01-01';
        }
        else {
          if (self.tempIntAssessHdr.VerifiedBy == '' || self.tempIntAssessHdr.VerifiedBy == null) {
            self.tempIntAssessHdr.VerifiedBy = self.$store.getters[StoreGetter.user].UserID;
          }
        }
        if (self.tempIntAssessHdr.DateOffer == '' || self.tempIntAssessHdr.DateOffer == undefined || self.tempIntAssessHdr.DateOffer == null) {
          self.tempIntAssessHdr.DateOffer = '1900-01-01';
        }
        self.tempIntAssessHdr.BasicSalary = Number(self.tempIntAssessHdr.BasicSalary);
        self.tempIntAssessHdr.Allw = Number(self.tempIntAssessHdr.Allw);
        self.tempIntAssessHdr.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
        self.tempIntAssessHdr.AddBy = self.$store.getters[StoreGetter.user].UserID;
        self.tempIntAssessHdr.IntAssessLogModel.CandID = self.tempIntAssessHdr.CandID;
        self.tempIntAssessHdr.IntAssessLogModel.JobAdCode = self.tempIntAssessHdr.JobAdCode;
        self.tempIntAssessHdr.IntAssessLogModel.Seq = Number(self.tempIntAssessHdr.Seq);
        self.tempIntAssessHdr.IntAssessLogModel.IntStatus = self.tempIntAssessHdr.IntStatus;
        self.tempIntAssessHdr.IntAssessLogModel.LogBy = self.$store.getters[StoreGetter.user].UserID;
        var obj = {
          model: self.tempIntAssessHdr,
        }
        if (self.interViewStatus == "92") {
          self.saveIntScheduleAndStaff(obj);
        }
        else {
          self.saveIntAssessHdr(obj);
        }
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    async saveIntAssessHdr(obj) {
      var self = this;
      const response = await IntAssessHdrService.updateIntSchedule(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", self.t.t(self.dictEnum.MSG_InterviewSubmit));
        self.resetData();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveIntScheduleAndStaff(obj) {
      var self = this;
      const response = await IntAssessHdrService.saveIntScheduleAndStaff(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", self.t.t(self.dictEnum.MSG_InterviewSubmit));
        self.resetData();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    resetData: function () {
      var self = this;
      self.interViewStatus = '';
      self.tempIntAssessHdr = new IntAssessHdr();
      self.IsLoaded = true;
      self.jobCode = '';
      self.status = '';
      self.offerBy = '';
      self.searchText = '';
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.goPage = '';
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = self.currentSelectedPage + 1;
      self.totalRecords = 0;
      self.init();
      self.getAllEnquiryIntAssessHdrList();
    },
    fillIntAssessHdrData: function () {
      var self = this;
      self.IsLoaded = false;
      if (self.intAssessHdrList != null && self.intAssessHdrList.length > 0) {
        var tempCode = 1;
        self.intAssessHdrList.forEach(
          (element) => {
            var jobCodeDetail = self.jobCodeList.find((obj) => obj.JobCode == element.JobCode);
            if (jobCodeDetail != null && jobCodeDetail != undefined) {
              element.JobName = self.user.Lang == 'EN' ? jobCodeDetail.EDesc : jobCodeDetail.CDesc;
            }
            if (element.DateCommence == null || element.DateCommence == undefined || element.DateCommence == '1900-01-01') {
              element.DateCommence = "";
            }
            if (element.DateOffer == null || element.DateOffer == undefined || element.DateOffer == '1900-01-01') {
              element.DateOffer = "";
            }
            if (element.DateContSign == null || element.DateContSign == undefined || element.DateContSign == '1900-01-01') {
              element.DateContSign = "";
            }
            if (element.DateRefChk == null || element.DateRefChk == undefined || element.DateRefChk == '1900-01-01') {
              element.DateRefChk = "";
            }
            if (element.DateDataEntry == null || element.DateDataEntry == undefined || element.DateDataEntry == '1900-01-01') {
              element.DateDataEntry = "";
            }
            if (element.DateVerified == null || element.DateVerified == undefined || element.DateVerified == '1900-01-01') {
              element.DateVerified = "";
            }
            element.tempCode = tempCode;
            element.IsEditMode = false;
            tempCode++;
          });
        self.IsLoaded = true;
      }
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.currentSelectedPage = pagenumber - 1;
      this.setPage();
    },
    goNextPage() {
      var pagenumber = Number(this.goPage);
      if (pagenumber <= this.totalNoOfPages && pagenumber != 0) {
        this.currentPage = pagenumber;
        this.currentSelectedPage = pagenumber - 1;
        this.setPage();
      }
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1) - 1;
      if (this.skip != 0) {
        this.skip++;
      }
      this.getAllEnquiryIntAssessHdrList();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090400-Enquiry/S090400-Enquiry.js